import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, X, MinusCircle } from "lucide-react";

export const STATUSES = [
  { v: "present", label: "Present", icon: Check, color: "bg-green-600 hover:bg-green-700 text-white border-green-600" },
  { v: "absent", label: "Absent", icon: X, color: "bg-red-600 hover:bg-red-700 text-white border-red-600" },
  { v: "excused", label: "Excused", icon: MinusCircle, color: "bg-amber-500 hover:bg-amber-600 text-white border-amber-500" },
];

export default function AttendanceRow({ member: m, status, onChange }) {
  return (
    <Card className="card-shadow-soft" data-testid={`att-row-${m.id}`}>
      <CardContent className="p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <div className="font-semibold">{m.full_name}</div>
          {m.parent_guardian && <div className="text-xs text-muted-foreground">Guardian: {m.parent_guardian}</div>}
        </div>
        <div className="flex gap-1.5">
          {STATUSES.map(({ v, label, icon: Icon, color }) => (
            <Button key={v} size="sm" variant="outline" data-testid={`att-${m.id}-${v}`}
              onClick={() => onChange(m.id, v)} className={`min-h-[44px] px-3 border ${status === v ? color : ""}`}>
              <Icon className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">{label}</span>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
